/**
 * S5 Portal-Suche ohne Composer-Chat.
 * Klasse SUCHE_CLICK_NOT_CHAT: Suche weit, Join eng.
 *
 * HTTP wie Composer (n8n ARKO_AGENT → /v1/lex/answer bzw. /v1/jud/answer),
 * aber ohne Chat-Bubbles, ohne Document-Context, ohne lexCarry/Auto-Join.
 * Keine Frontend-Imports — Gate transpiliert diese Datei isoliert.
 */

export const PORTAL_SUCHE_CLASS = 'SUCHE_CLICK_NOT_CHAT';

/** Markierte Treffer → Compose nur dieser IDs. Keine Extra-Normen, kein Silent-Join. */
export const PORTAL_SUCHE_MARKED_CLASS = 'SUCHE_MARKED_COMPOSE_ONLY';

export const PORTAL_SUCHE_MARKED_EMPTY_HINT =
  'Noch kein Begriff in der Suchleiste angeheftet. Bitte zuerst anheften — ohne Eintrag wird nichts zusammengefasst.';

export const PORTAL_SUCHE_MARKED_DISCLAIMER =
  'Orientierung/Entwurf, keine Rechtsberatung (§ 9 RAO). Anwaltlich zu prüfen.';

export const PORTAL_SUCHE_MARKED_LEX_TAIL =
  'Kurzer Überblick ausschließlich zu diesen genannten Paragraphen — keine Fallanalyse, keine weiteren Normen, kein Sachverhalt.';

export const PORTAL_SUCHE_MARKED_NO_RIS =
  'Kein RIS-Wortlaut zu den markierten Treffern — nichts ergänzt.';

/** Pro Chip ohne LEX-Hit — ehrlich, kein stilles Weglassen, kein Halluzinations-Text. */
export const PORTAL_SUCHE_MARKED_SKIP =
  'Nicht im aktuellen Bestand — nichts ergänzt.';

/** Compose-Überschrift in der Hauptfläche — kein Listen-Satz der Chips. */
export const PORTAL_SUCHE_MARKED_ORIENTATION_LEAD = 'Zusammenfassung:';

/** Titel/Kopf-Brücke, kein RIS-Volltext. */
export const PORTAL_SUCHE_MARKED_ORIENTATION_FROM_HEAD = 'laut Überschrift';

export const PORTAL_SUCHE_MARKED_ORIENTATION_SKIP_TAIL =
  'im aktuellen Bestand nicht auffindbar.';

export const PORTAL_SUCHE_MARKED_ORIENTATION_HIT_TAIL =
  'liegt als RIS-Treffer vor (Wortlaut unten).';

/** Pfad-Klappe wie ARKO-Nachvollziehbarkeit: Default zu, Schritte statt Token-Log. */
export const PORTAL_SUCHE_MARKED_PATH_LABEL = 'Wie die Antwort zustande kam';
export const PORTAL_SUCHE_MARKED_PATH_KIND = 'Orientierung / Entwurf / § 9 RAO';
export const PORTAL_SUCHE_MARKED_PATH_PINNED = 'Angeheftet';
export const PORTAL_SUCHE_MARKED_PATH_RETRIEVE = 'Nachgeschlagen';
export const PORTAL_SUCHE_MARKED_PATH_COMPOSE_CLOSE =
  'Übersicht nur aus genau diesen Treffern — keine weiteren Normen.';
export const PORTAL_SUCHE_MARKED_PATH_HIT = 'Treffer';
export const PORTAL_SUCHE_MARKED_PATH_SKIP_STATUS = 'kein Treffer';
/** Demo-Fläche: kein Intern-Wort LEXCORE — RIS / Normbestand. */
export const PORTAL_SUCHE_MARKED_PATH_SOURCE_LEX = 'RIS';
export const PORTAL_SUCHE_MARKED_PATH_SOURCE_NORM = 'Normbestand';
export const PORTAL_SUCHE_MARKED_PATH_SOURCE_JUD = 'OGH';

/** Sichtbares Pin-Label — nicht sr-only, nicht nur native Checkbox. */
export const PORTAL_SUCHE_MARK_LABEL = 'Zur gemeinsamen Suche merken';
export const PORTAL_SUCHE_MARKED_PIN_LABEL = 'Gemerkt';
export const PORTAL_SUCHE_MARK_PIN_LABEL = 'Merken';

/** Suchleisten-Pin: Begriff oder § anhängen, ohne die Trefferliste zu zwingen. */
export const PORTAL_SUCHE_BAR_PIN_LABEL = 'Anheften';
export const PORTAL_SUCHE_BAR_PIN_HINT =
  'Begriff oder Paragraph anheften — noch nicht suchen';
export const PORTAL_SUCHE_BAR_COMPOSE_LABEL = 'Markierte suchen';

export const PORTAL_SUCHE_TABS = [
  { id: 'lex', label: '§ / Normen' },
  { id: 'jud', label: 'OGH / Judikatur' },
] as const;

export const PORTAL_SUCHE_PAGE_TITLE = 'Suche';
export const PORTAL_SUCHE_PAGE_SUBTITLE =
  'Begriff oder Paragraph in der Leiste anheften, dann gemeinsam suchen. Ohne Anheften: einzelne Suche.';
export const PORTAL_SUCHE_TABLIST_LABEL = 'Suchbereich';
export const PORTAL_SUCHE_INPUT_LABEL_JUD = 'Judikatur suchen';
export const PORTAL_SUCHE_INPUT_LABEL_LEX = 'Paragraph suchen';
export const PORTAL_SUCHE_PLACEHOLDER_JUD = 'z. B. Befristung MRG oder 5 Ob 200/24';
export const PORTAL_SUCHE_PLACEHOLDER_LEX = 'z. B. Befristung Miete oder § 16 MRG';
export const PORTAL_SUCHE_SUBMIT_LABEL = 'Suchen';
export const PORTAL_SUCHE_COPY_LABEL = 'Kopieren';
export const PORTAL_SUCHE_RIS_LABEL = 'RIS';
export const PORTAL_SUCHE_RIS_OPEN_LABEL = 'RIS öffnen';

const PORTAL_SUCHE_RIS_HOST = 'ris.bka.gv.at';

/**
 * Externer RIS-Href für die Normenkarte.
 * Nur https auf ris.bka.gv.at. Portal-Suche, andere Hosts und Credentials bleiben leer.
 */
export function portalSucheExternalRisHref(raw: unknown): string {
  const text = String(raw || '').trim();
  if (!text) return '';
  let parsed: URL;
  try {
    parsed = new URL(text);
  } catch {
    return '';
  }
  if (parsed.protocol !== 'https:') return '';
  if (parsed.username || parsed.password) return '';
  const host = parsed.hostname.toLowerCase();
  if (host !== PORTAL_SUCHE_RIS_HOST && host !== `www.${PORTAL_SUCHE_RIS_HOST}`) return '';
  return text;
}

export const PORTAL_SUCHE_NORM_REFS_LABEL = 'Normbezüge';
export const PORTAL_SUCHE_RECOGNIZED_PREFIX = 'Erkannt:';
export const PORTAL_SUCHE_PENDING = 'Suche läuft…';
export const PORTAL_SUCHE_HEADING_COMPOSE = 'Markierte Suche';
export const PORTAL_SUCHE_HEADING_JUD_EXPLORE = 'Judikatur-Treffer';
export const PORTAL_SUCHE_HEADING_LEX_EXPLORE = 'Passende Normen';
export const PORTAL_SUCHE_HEADING_JUD_CITE = 'Judikatur';
export const PORTAL_SUCHE_HEADING_LEX_CITE = 'Normen';
export const PORTAL_SUCHE_HEADING_RIS_BLOCKS = 'Wortlaut / RIS';
export const PORTAL_SUCHE_MARKED_BAR_SELECTED =
  'Nur die gemerkten Treffer, mit deren RIS-Wortlaut.';
export const PORTAL_SUCHE_MARKED_BAR_HINT =
  'Zum gemeinsamen Suchen: Begriff in der Suchleiste anheften. Der Pin an der Karte ist optional.';
export const PORTAL_SUCHE_MODE_HINT_JUD_CITE =
  'Geschäftszahl erkannt. Anheften merkt sie in der Leiste. Ohne Eintrag: einzelne Suche.';
export const PORTAL_SUCHE_MODE_HINT_JUD_EXPLORE =
  'Stichwortsuche. Anheften sammelt Begriffe — „Markierte suchen“ wertet sie gemeinsam aus.';
export const PORTAL_SUCHE_MODE_HINT_LEX_CITE =
  'Paragraph erkannt. Anheften merkt ihn in der Leiste; danach gemeinsam suchen.';
export const PORTAL_SUCHE_MODE_HINT_LEX_EXPLORE =
  'Stichwortsuche. Zuerst in der Leiste anheften, dann gemeinsam suchen. Ohne Eintrag: einzelne Suche.';
export const PORTAL_SUCHE_EMPTY_EXPLORE =
  'Keine passenden Treffer. Anderes Stichwort versuchen oder einen konkreten Paragraphen mit Gesetz nennen (z. B. § 16 MRG).';
export const PORTAL_SUCHE_ERROR_EMPTY_JUD = 'Bitte einen Suchbegriff eingeben.';
export const PORTAL_SUCHE_ERROR_EMPTY_LEX = 'Bitte ein Thema oder einen Paragraphen eingeben.';
export const PORTAL_SUCHE_ERROR_TIMEOUT =
  'Die Suche hat zu lange gedauert. Bitte erneut versuchen.';
export const PORTAL_SUCHE_ERROR_UNREACHABLE =
  'Die Suche ist nicht erreichbar. Bitte die Verbindung prüfen und erneut versuchen.';
export const PORTAL_SUCHE_ERROR_ABORTED = 'Suche abgebrochen. Bitte erneut versuchen.';
export const PORTAL_SUCHE_COPY_BLOCKED =
  'Kopieren in die Zwischenablage ist in diesem Browser nicht erlaubt.';
export const PORTAL_SUCHE_PROOF_LABEL = 'Nachweis';
export const PORTAL_SUCHE_PROOF_LEX_SECTION = 'Quellen';
export const PORTAL_SUCHE_TRUST_VERIFIED_TITLE =
  'Wortlaut aus dem Normenbestand — Quellen im Nachweis.';
export const PORTAL_SUCHE_TRUST_UNVERIFIED_TITLE =
  'Allgemeine Orientierung ohne belegte Quelle — keine Rechtsberatung.';

export function portalSuchePathChipCountLabel(count: number): string {
  const n = Math.max(0, Number(count) || 0);
  return n === 1 ? '1 Eintrag' : `${n} Einträge`;
}

export type PortalSucheKind = (typeof PORTAL_SUCHE_TABS)[number]['id'];

/** cite = volle §-Zitation / Geschäftszahl; explore = grobe Beziehung → Trefferliste. */
export type PortalSucheMode = 'cite' | 'explore';

/** Gleicher Prefix wie Composer-Rechtsfrage — n8n routet LEXCORE nur bei diesem Intent. */
export const PORTAL_SUCHE_LEX_PREFIX =
  'Rechtsfrage (verifizierte Normen aus LEXCORE):\n\n';

/** Composer-§-Pfad: Lookup-Satz blockt Auto-Join, LEX ankert explizite Norm. */
export const PORTAL_SUCHE_LEX_CITE_TAIL =
  'Kurzer Normwortlaut bzw. Überblick aus LEXCORE — keine Fallanalyse und kein Sachverhalt.';

/**
 * Gesetzeskürzel nur zur Erkennung „volle §-Zitation“.
 * Kein Korpus — Explore geht ohne Pflicht §+Gesetz an denselben /v1/lex/answer.
 */
const PORTAL_SUCHE_LAW_ALT =
  'ABGB|MRG|WGG|WEG|KSchG|AngG|UrlG|EFZG|AZG|ArbVG|GlBG|DHG|AVRAG|MSchG|StGB|StPO|UGB|EO|ZPO|JN|RAO|GewO|DSG|DSGVO|LFG|GenG|MaklerG|UrhG|UStG|EStG|KStG|GmbHG|AktG|BAO|VStG|StVO|EheG|HGB|FBG|VVG|GBG|AVG|GOG|UWG|PatentG|MarkenG';

export const PORTAL_SUCHE_MODE = 'anwalts_arko';
export const PORTAL_SUCHE_TIMEOUT_MS = 45000;
export const PORTAL_SUCHE_CHIP_PARAGRAPH = 'paragraph_lookup' as const;
export const PORTAL_SUCHE_JUD_INTENT = 'judicature_recherche' as const;
export const PORTAL_SUCHE_JUD_PATH = '/v1/jud/answer';
export const PORTAL_SUCHE_JUD_TOP_K = 5;

/** Keys, die Join/Fallkontext einschleppen würden — Suche bleibt unabhängig. */
export const PORTAL_SUCHE_STRIP_BODY_KEYS = [
  'akteId',
  'akteTitle',
  'akte_nc_path',
  'activeDocumentId',
  'openDocuments',
  'documentExtractFingerprint',
  'documentContext',
  'documentAlreadyAnalyzed',
  'skipProactiveFrist',
  'lexCarry',
  'memContext',
  'webArticleMeta',
  'joinTopic',
] as const;

const TENANT_KEEP_KEYS = [
  'customerId',
  'kanzlei',
  'email',
  'tier',
  'tenant',
  'isPremium',
] as const;

export function portalSucheKindFromTab(tab: string): PortalSucheKind {
  return tab === 'jud' ? 'jud' : 'lex';
}

function trimmedQuery(query: string): string {
  return String(query || '').replace(/\s+/g, ' ').trim();
}

function shortenSucheSnippet(raw: string, max = 180): string {
  const text = String(raw || '').replace(/\s+/g, ' ').trim();
  if (!text) return '';
  if (text.length <= max) return text;
  return text.slice(0, max - 1).trimEnd() + '…';
}

/** Buchstaben-Suffix am § (24f, 29a) — nicht nur \\d+. */
const PORTAL_SUCHE_SECTION = String.raw`\d{1,4}[a-zA-Z]?`;

function prettyPortalSucheSection(raw: string): string {
  return String(raw || '').replace(/[A-Za-z]+$/, (letters) => letters.toLowerCase());
}

/** MRG-16 → „§ 16 MRG“; LFG-24F → „§ 24f LFG“. */
export function portalSucheNormIdToLabel(normId: string): string {
  const s = String(normId || '').trim();
  const m = s.match(new RegExp(String.raw`^([A-Za-zÄÖÜ][A-Za-zÄÖÜ0-9.-]{1,14})-(${PORTAL_SUCHE_SECTION})$`, 'i'));
  if (m) return `\u00a7 ${prettyPortalSucheSection(m[2])} ${m[1].toUpperCase()}`;
  return s;
}

/** Kanon `LAW-NUM` case-insensitive — `LFG-24f` und `LFG-24F` sind dieselbe Norm. */
export function portalSucheCanonNormId(raw: string): string {
  const s = String(raw || '').trim();
  if (!s) return '';
  const fromQuery = isPrecisePortalSucheLexQuery(s) ? portalSucheLexQueryToNormId(s) : '';
  const id = fromQuery || s;
  const m = id.match(new RegExp(String.raw`^([A-Za-zÄÖÜ][A-Za-zÄÖÜ0-9.-]{1,14})-(${PORTAL_SUCHE_SECTION})$`, 'i'));
  if (m) return `${m[1].toUpperCase()}-${m[2].toUpperCase()}`;
  return s.replace(/\u00a7/g, '').replace(/\s+/g, ' ').trim().toUpperCase();
}

export function portalSucheNormIdsEqual(a: string, b: string): boolean {
  const left = portalSucheCanonNormId(a);
  const right = portalSucheCanonNormId(b);
  return Boolean(left && right && left === right);
}

/** Präzise LEX: Zahl + optionales Buchstaben-Suffix + Gesetz (z. B. § 16 MRG, § 24f LFG). */
export function isPrecisePortalSucheLexQuery(query: string): boolean {
  const t = trimmedQuery(query);
  if (!t) return false;
  const law = PORTAL_SUCHE_LAW_ALT;
  const sectionLaw = new RegExp(
    String.raw`(?:\u00a7{1,2}\s*)?${PORTAL_SUCHE_SECTION}(?:\s*(?:Abs\.?|Absatz)\s*\d{1,2})?\s+(?:${law})\b`,
    'i',
  );
  const lawSection = new RegExp(
    String.raw`(?:${law})\s*(?:\u00a7{1,2}\s*)?${PORTAL_SUCHE_SECTION}(?:\s*(?:Abs\.?|Absatz)\s*\d{1,2})?\b`,
    'i',
  );
  const idForm = new RegExp(String.raw`(?:${law})-${PORTAL_SUCHE_SECTION}\b`, 'i');
  const wordForm = new RegExp(
    String.raw`\b(?:paragraf|paragraph)(?:en)?\s*${PORTAL_SUCHE_SECTION}\s+(?:${law})\b`,
    'i',
  );
  return sectionLaw.test(t) || lawSection.test(t) || idForm.test(t) || wordForm.test(t);
}

/** Präzise LEX-Query → `MRG-16` / `LFG-24f`. Freitext bleibt leer — kein geratenes Extra-ID. */
export function portalSucheLexQueryToNormId(query: string): string {
  const t = trimmedQuery(query);
  if (!t || !isPrecisePortalSucheLexQuery(t)) return '';
  const law = PORTAL_SUCHE_LAW_ALT;
  const idForm = t.match(new RegExp(String.raw`(?:${law})-(${PORTAL_SUCHE_SECTION})\b`, 'i'));
  if (idForm) {
    const lawMatch = t.match(new RegExp(String.raw`(${law})-`, 'i'));
    if (lawMatch?.[1] && idForm[1]) {
      return `${lawMatch[1].toUpperCase()}-${prettyPortalSucheSection(idForm[1])}`;
    }
  }
  const sectionLaw = t.match(
    new RegExp(
      String.raw`(?:\u00a7{1,2}\s*)?(${PORTAL_SUCHE_SECTION})(?:\s*(?:Abs\.?|Absatz)\s*\d{1,2})?\s+(${law})\b`,
      'i',
    ),
  );
  if (sectionLaw?.[1] && sectionLaw[2]) {
    return `${sectionLaw[2].toUpperCase()}-${prettyPortalSucheSection(sectionLaw[1])}`;
  }
  const lawSection = t.match(
    new RegExp(
      String.raw`(${law})\s*(?:\u00a7{1,2}\s*)?(${PORTAL_SUCHE_SECTION})(?:\s*(?:Abs\.?|Absatz)\s*\d{1,2})?\b`,
      'i',
    ),
  );
  if (lawSection?.[1] && lawSection[2]) {
    return `${lawSection[1].toUpperCase()}-${prettyPortalSucheSection(lawSection[2])}`;
  }
  return '';
}

/** Präzise JUD: Geschäftszahl oder RS-Nummer. Thema/Stichwort bleibt explore. */
export function isPrecisePortalSucheJudQuery(query: string): boolean {
  const t = trimmedQuery(query);
  if (!t) return false;
  if (/\bRS\d{6,8}\b/i.test(t)) return true;
  return /\b\d{1,2}\s*[A-Za-z]{1,4}\s+\d{1,5}\s*\/\s*\d{2}[a-z]?\b/.test(t);
}

export function portalSucheMode(kind: PortalSucheKind, query: string): PortalSucheMode {
  if (!trimmedQuery(query)) return 'explore';
  if (kind === 'jud') return isPrecisePortalSucheJudQuery(query) ? 'cite' : 'explore';
  return isPrecisePortalSucheLexQuery(query) ? 'cite' : 'explore';
}

/**
 * Retrieve-Anker für grobe LEX-Suche — dieselben Topic-Queries wie n8n
 * (MIET_TOPIC_NORM_QUERIES), nur wenn das Thema klar mietrechtlich ist.
 * Ohne Anker bleibt /v1/lex/answer unter min_score=0.55 leer; min_score senken
 * liefert fachfremde Hits (MaklerG) — das ist kein Explore.
 */
const PORTAL_SUCHE_MIETE_SCOPE =
  /\b(miete|mietrecht|mietvertrag|mieter|vermieter|\bmrg\b|wohnung|mietsache)\b/i;

const PORTAL_SUCHE_EXPLORE_HINTS: ReadonlyArray<{ topic: RegExp; q: string }> = [
  { topic: /\bbefrist/i, q: '\u00a7 29 MRG Befristung Mietvertrag' },
  { topic: /\bmietzins|hauptmietzins|wertsicherung/i, q: '\u00a7 17 MRG Hauptmietzins' },
  { topic: /\bbetriebskosten/i, q: '\u00a7 21 MRG Betriebskosten' },
  { topic: /\bkaution/i, q: '\u00a7 1100 ABGB Kaution Miete' },
  { topic: /\buntervermiet/i, q: '\u00a7 537 ABGB Untervermietung' },
  { topic: /\bk(?:\u00fc|ue)ndig/i, q: '\u00a7 30 MRG Kuendigung Mietvertrag' },
  { topic: /\b(mangel|feucht|schimmel|erhaltung|brauchbar)/i, q: '\u00a7 1096 ABGB Mangel Mietsache' },
  { topic: /\beigenbedarf/i, q: '\u00a7 30 MRG Eigenbedarf' },
];

export function portalSucheLexExploreRetrievalQuery(query: string): string {
  const trimmed = trimmedQuery(query);
  if (!trimmed || isPrecisePortalSucheLexQuery(trimmed)) return trimmed;
  if (!PORTAL_SUCHE_MIETE_SCOPE.test(trimmed)) return trimmed;
  const hints: string[] = [];
  const seen = new Set<string>();
  for (const rule of PORTAL_SUCHE_EXPLORE_HINTS) {
    if (!rule.topic.test(trimmed)) continue;
    if (seen.has(rule.q)) continue;
    seen.add(rule.q);
    hints.push(rule.q);
    if (hints.length >= 4) break;
  }
  if (!hints.length) return trimmed;
  return `${trimmed}\n${hints.join('; ')}`.slice(0, 1000);
}

/**
 * Präzise: Composer-§-Nachschlagen (Join-Blocker-Satz).
 * Grob: Rechtsfrage-Prefix + Rohquery, plus Topic-Retrieve-Anker wenn Miet-Scope.
 */
export function buildPortalSucheLexChatInput(query: string): string | null {
  const trimmed = trimmedQuery(query);
  if (!trimmed) return null;
  const clipped = trimmed.slice(0, 1000);
  if (isPrecisePortalSucheLexQuery(clipped)) {
    return (
      `${PORTAL_SUCHE_LEX_PREFIX}` +
      `Bitte nur nachschlagen: ${clipped}. ` +
      PORTAL_SUCHE_LEX_CITE_TAIL
    );
  }
  return `${PORTAL_SUCHE_LEX_PREFIX}${portalSucheLexExploreRetrievalQuery(clipped)}`;
}

export function buildPortalSucheLexRequest(query: string): {
  intent: 'rechtsfrage';
  chip_action: typeof PORTAL_SUCHE_CHIP_PARAGRAPH;
  chatInput: string;
} | null {
  const chatInput = buildPortalSucheLexChatInput(query);
  if (!chatInput) return null;
  return {
    intent: 'rechtsfrage',
    chip_action: PORTAL_SUCHE_CHIP_PARAGRAPH,
    chatInput,
  };
}

export function buildPortalSucheJudRequest(query: string): {
  intent: typeof PORTAL_SUCHE_JUD_INTENT;
  judicatureMode: true;
  chatInput: string;
} | null {
  const chatInput = trimmedQuery(query).slice(0, 1000);
  if (!chatInput) return null;
  return {
    intent: PORTAL_SUCHE_JUD_INTENT,
    judicatureMode: true,
    chatInput,
  };
}

export function buildPortalSucheLookup(
  kind: PortalSucheKind,
  query: string,
): {
  kind: PortalSucheKind;
  intent: 'rechtsfrage' | typeof PORTAL_SUCHE_JUD_INTENT;
  chatInput: string;
  chip_action?: typeof PORTAL_SUCHE_CHIP_PARAGRAPH;
  judicatureMode?: true;
} | null {
  if (kind === 'jud') {
    const req = buildPortalSucheJudRequest(query);
    if (!req) return null;
    return {
      kind,
      intent: req.intent,
      chatInput: req.chatInput,
      judicatureMode: true,
    };
  }
  const req = buildPortalSucheLexRequest(query);
  if (!req) return null;
  return {
    kind,
    intent: req.intent,
    chatInput: req.chatInput,
    chip_action: req.chip_action,
  };
}

/** Tenant-Auth für n8n, ohne Akt-/Dokument-/Join-Felder. */
export function portalSucheTenantExtras(
  extraBody: Record<string, unknown> | undefined | null,
): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  if (!extraBody || typeof extraBody !== 'object') return out;
  for (const key of TENANT_KEEP_KEYS) {
    if (extraBody[key] !== undefined && extraBody[key] !== null && extraBody[key] !== '') {
      out[key] = extraBody[key];
    }
  }
  return out;
}

export function buildPortalSucheWebhookBody(opts: {
  kind: PortalSucheKind;
  query: string;
  extraBody?: Record<string, unknown> | null;
  requestId: string;
}): Record<string, unknown> | null {
  const lookup = buildPortalSucheLookup(opts.kind, opts.query);
  if (!lookup) return null;
  const body: Record<string, unknown> = {
    chatInput: lookup.chatInput,
    history: [],
    mode: PORTAL_SUCHE_MODE,
    request_id: opts.requestId,
    stream: true,
    preferStream: true,
    intent: lookup.intent,
    ...portalSucheTenantExtras(opts.extraBody),
  };
  if (lookup.chip_action) body.chip_action = lookup.chip_action;
  if (lookup.judicatureMode) body.judicatureMode = true;
  for (const key of PORTAL_SUCHE_STRIP_BODY_KEYS) {
    delete body[key];
  }
  return body;
}

export function portalSucheBodyHasJoin(body: Record<string, unknown> | null): boolean {
  if (!body) return false;
  if (body.lexCarry != null) return true;
  if (body.joinTopic != null) return true;
  if (body.chip_action === 'ogh_dazu') return true;
  if (body.documentContext != null && String(body.documentContext).trim()) return true;
  return false;
}

export interface PortalSucheExploreHit {
  key: string;
  title: string;
  paragraph: string;
  short: string;
  /** Voller Fragmenttext aus dem Treffer. `short` bleibt die Kurzzeile. */
  wortlaut?: string;
  /** Nur wenn der Treffer `valid_from` schon mitbringt. */
  validFrom?: string;
  risUrl: string;
  citeQuery: string;
  /**
   * Nur das schon mitgelieferte Feld (`norm_chain` / `cross_refs`).
   * Fehlt es an der Karte, bleiben Querverweis-Chips weg.
   */
  normChain?: unknown;
}

export type PortalSucheWortlautZeile = {
  kind: 'text' | 'ziffer';
  text: string;
};

export type PortalSucheWortlautAbsatz = {
  /** Leer, wenn der Wortlaut keine Absatz-Nummer trägt. */
  nummer: string;
  zeilen: PortalSucheWortlautZeile[];
};

export type PortalSucheNormChainChip = {
  normId: string;
  label: string;
  query: string;
};

const PORTAL_SUCHE_ABSATZ_LINE =
  /(?:^|\n)[ \t]*\((\d{1,3}[a-z]?)\)(?=[ \t]|\n|$)/g;
const PORTAL_SUCHE_ABSATZ_INLINE =
  /(?:^|\s)\((\d{1,3}[a-z]?)\)(?=\s|$)/g;

function portalSucheDeliveredChain(rec: Record<string, unknown> | null): unknown[] | undefined {
  if (!rec) return undefined;
  const raw = rec.norm_chain ?? rec.normChain ?? rec.cross_refs ?? rec.crossRefs;
  return Array.isArray(raw) ? raw : undefined;
}

function portalSucheAbsatzMarkers(
  text: string,
  re: RegExp,
): Array<{ markerStart: number; contentStart: number; nummer: string }> {
  const out: Array<{ markerStart: number; contentStart: number; nummer: string }> = [];
  re.lastIndex = 0;
  let match: RegExpExecArray | null;
  while ((match = re.exec(text))) {
    const full = match[0];
    const parenAt = full.lastIndexOf('(');
    out.push({
      markerStart: match.index + parenAt,
      contentStart: match.index + full.length,
      nummer: match[1],
    });
    if (match.index === re.lastIndex) re.lastIndex += 1;
  }
  return out;
}

function portalSucheWortlautZeilen(chunk: string): PortalSucheWortlautZeile[] {
  const lines = String(chunk || '').replace(/\r\n/g, '\n').split('\n');
  const out: PortalSucheWortlautZeile[] = [];
  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed) {
      if (out.length && out[out.length - 1].text !== '') out.push({ kind: 'text', text: '' });
      continue;
    }
    const ziffer = trimmed.match(/^(\d{1,3}\.)\s+(\S.*)$/);
    if (ziffer) {
      out.push({ kind: 'ziffer', text: `${ziffer[1]} ${ziffer[2]}` });
      continue;
    }
    out.push({ kind: 'text', text: trimmed });
  }
  while (out.length && out[out.length - 1].text === '') out.pop();
  return out;
}

/**
 * Absätze nur aus dem schon gelieferten Wortlaut.
 * `(1)` `(2)` am Zeilenanfang (sonst im Fließtext, wenn mindestens zwei Marker da sind)
 * oder klare Leerzeilen → eine Karte je Absatz. `1.` `2.` bleiben Ziffern im Absatz.
 * Ohne Marker und ohne Leerzeile: ein Block. Kein ergänzter Rechtstext.
 */
export function portalSucheWortlautAbsaetze(raw: string): PortalSucheWortlautAbsatz[] {
  const text = String(raw || '').replace(/\r\n/g, '\n').trim();
  if (!text) return [];
  const lineMarkers = portalSucheAbsatzMarkers(text, PORTAL_SUCHE_ABSATZ_LINE);
  const markers =
    lineMarkers.length >= 2
      ? lineMarkers
      : (() => {
          const inline = portalSucheAbsatzMarkers(text, PORTAL_SUCHE_ABSATZ_INLINE);
          return inline.length >= 2 ? inline : lineMarkers;
        })();
  if (markers.length > 0) {
    const blocks: PortalSucheWortlautAbsatz[] = [];
    const preamble = text.slice(0, markers[0].markerStart).trim();
    if (preamble) {
      const zeilen = portalSucheWortlautZeilen(preamble);
      if (zeilen.length) blocks.push({ nummer: '', zeilen });
    }
    for (let i = 0; i < markers.length; i += 1) {
      const end = i + 1 < markers.length ? markers[i + 1].markerStart : text.length;
      const body = text.slice(markers[i].contentStart, end).trim();
      const zeilen = portalSucheWortlautZeilen(body);
      if (!zeilen.length) continue;
      blocks.push({ nummer: markers[i].nummer, zeilen });
    }
    return blocks;
  }
  const parts = text
    .split(/\n[ \t]*\n+/)
    .map((part) => part.trim())
    .filter(Boolean);
  if (parts.length >= 2) {
    return parts.map((part, index) => ({
      nummer: String(index + 1),
      zeilen: portalSucheWortlautZeilen(part),
    }));
  }
  return [{ nummer: '', zeilen: portalSucheWortlautZeilen(text) }];
}

function portalSucheChainViaIsCrossRef(via: string): boolean {
  return via.startsWith('cross_ref:') || via === 'related' || via === 'cross_ref';
}

/** Chips nur aus dem mitgelieferten Ketten-Feld. Kein Nachladen, kein Join. */
export function portalSucheCrossRefChips(
  normChain: unknown,
  selfNormId = '',
): PortalSucheNormChainChip[] {
  if (!Array.isArray(normChain) || !normChain.length) return [];
  const self = portalSucheCanonNormId(selfNormId);
  const out: PortalSucheNormChainChip[] = [];
  const seen = new Set<string>();
  for (const item of normChain) {
    if (typeof item === 'string') {
      const normId = item.trim();
      if (!normId) continue;
      const canon = portalSucheCanonNormId(normId) || normId;
      if ((self && canon === self) || seen.has(canon)) continue;
      seen.add(canon);
      const label = portalSucheNormIdToLabel(normId);
      out.push({ normId: canon, label, query: label });
      continue;
    }
    const rec = asRecord(item);
    if (!rec) continue;
    const via = String(rec.via || '').trim();
    if (!portalSucheChainViaIsCrossRef(via)) continue;
    const normId = String(rec.norm_id || rec.normId || '').trim();
    if (!normId) continue;
    const canon = portalSucheCanonNormId(normId) || normId;
    if ((self && canon === self) || seen.has(canon)) continue;
    seen.add(canon);
    const label = portalSucheNormIdToLabel(normId);
    out.push({ normId: canon, label, query: label });
  }
  return out;
}

function asRecord(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
}

/** Explore-Hits aus LEXCORE-sources — auch bei unverifizierter Diagnose, kein Fake-Normtext. */
export function portalSucheExploreHitsFromLexSources(raw: unknown): PortalSucheExploreHit[] {
  let list: unknown[] = [];
  let parentChain: unknown[] | undefined;
  if (Array.isArray(raw)) {
    list = raw;
  } else {
    const rec = asRecord(raw);
    if (rec) {
      parentChain = portalSucheDeliveredChain(rec);
      if (Array.isArray(rec.sources)) list = rec.sources;
      else {
        const proof = asRecord(rec.lexProof);
        if (proof && Array.isArray(proof.sources)) {
          list = proof.sources;
          parentChain = parentChain || portalSucheDeliveredChain(proof);
        }
      }
    }
  }
  const out: PortalSucheExploreHit[] = [];
  const seen = new Set<string>();
  for (const item of list) {
    const rec = asRecord(item);
    if (!rec) continue;
    const normId = String(rec.norm_id || rec.normId || '').trim();
    if (!normId || seen.has(normId)) continue;
    seen.add(normId);
    const paragraph = portalSucheNormIdToLabel(normId);
    const title = String(rec.title || '').trim() || paragraph;
    const fragment = String(rec.fragment_text || rec.fragmentText || '').trim();
    const risUrl = String(rec.ris_url || rec.risUrl || '').trim();
    const validFrom = String(rec.valid_from || rec.validFrom || '').trim();
    const ownChain = portalSucheDeliveredChain(rec);
    out.push({
      key: normId,
      title,
      paragraph,
      short: shortenSucheSnippet(fragment || title),
      wortlaut: fragment,
      validFrom,
      risUrl: risUrl.startsWith('http') ? risUrl : '',
      citeQuery: paragraph,
      normChain: ownChain,
    });
  }
  if (out.length === 1 && !out[0].normChain && parentChain) {
    out[0].normChain = parentChain;
  }
  return out;
}

export function portalSucheExploreHitsFromJudCases(raw: unknown): PortalSucheExploreHit[] {
  let list: unknown[] = [];
  if (Array.isArray(raw)) {
    list = raw;
  } else {
    const rec = asRecord(raw);
    if (rec) {
      if (Array.isArray(rec.cases)) list = rec.cases;
      else {
        const proof = asRecord(rec.judProof);
        if (proof && Array.isArray(proof.cases)) list = proof.cases;
      }
    }
  }
  const out: PortalSucheExploreHit[] = [];
  const seen = new Set<string>();
  for (const item of list) {
    const rec = asRecord(item);
    if (!rec) continue;
    const gz = String(rec.geschaeftszahl || rec.case_id || rec.caseId || '').trim();
    const key = String(rec.case_id || rec.caseId || gz).trim();
    if (!key || seen.has(key)) continue;
    seen.add(key);
    const title = String(rec.leitsatz || '').trim() || gz || key;
    const core = Array.isArray(rec.kernsaetze)
      ? rec.kernsaetze
      : Array.isArray(rec.rechtssaetze)
        ? rec.rechtssaetze
        : [];
    const firstCore = core
      .map((line) => String(line || '').trim())
      .find(Boolean);
    const risUrl = String(rec.source_url || rec.sourceUrl || '').trim();
    const wortlaut = core
      .map((line) => String(line || '').trim())
      .filter(Boolean)
      .join('\n\n');
    out.push({
      key,
      title,
      paragraph: gz || key,
      short: shortenSucheSnippet(firstCore || title),
      wortlaut: wortlaut || String(firstCore || '').trim(),
      risUrl: risUrl.startsWith('http') ? risUrl : '',
      citeQuery: gz || key,
    });
  }
  return out;
}

export function unwrapPortalArkoWebhookPayload(data: unknown): Record<string, unknown> {
  const root = data && typeof data === 'object' ? (data as Record<string, unknown>) : {};
  const raw = root.data ?? data;
  const item = Array.isArray(raw) ? raw[0] : raw;
  if (item && typeof item === 'object' && !Array.isArray(item)) {
    const rec = item as Record<string, unknown>;
    if (rec.json && typeof rec.json === 'object' && !Array.isArray(rec.json)) {
      return rec.json as Record<string, unknown>;
    }
    return rec;
  }
  return root;
}

/** SSE-Pfad aus n8n-Antwort — gleicher Vertrag wie InlineChat, ohne Chat-State. */
export function portalSucheStreamPath(payload: unknown): string {
  const rec = unwrapPortalArkoWebhookPayload(payload);
  if (rec.mode !== 'stream') return '';
  const stream = rec.stream;
  if (!stream || typeof stream !== 'object' || Array.isArray(stream)) return '';
  return String((stream as { path?: unknown }).path || '').trim();
}

export interface PortalSucheHitRaw {
  kind: PortalSucheKind;
  text: string;
  lexProof: unknown;
  judProof: unknown;
}

export function parsePortalSucheHitRaw(
  kind: PortalSucheKind,
  payload: unknown,
  draftText = '',
): PortalSucheHitRaw {
  const rec = unwrapPortalArkoWebhookPayload(payload);
  const inner =
    rec.payload && typeof rec.payload === 'object' && !Array.isArray(rec.payload)
      ? (rec.payload as Record<string, unknown>)
      : rec;
  const picked = [
    inner.output,
    inner.text,
    inner.reply,
    inner.einordnung,
    inner.answer,
    rec.output,
    rec.text,
    rec.reply,
    rec.einordnung,
    draftText,
  ];
  let text = '';
  for (const value of picked) {
    const piece = String(value ?? '').trim();
    if (piece) {
      text = piece;
      break;
    }
  }
  return {
    kind,
    text,
    lexProof: inner.lexProof ?? rec.lexProof ?? null,
    judProof: inner.judProof ?? rec.judProof ?? null,
  };
}

export function portalSucheHttpErrorMessage(status: number): string {
  if (status === 404) {
    return 'Die Suche ist auf diesem System noch nicht verfügbar. Bitte ARKORBIT informieren.';
  }
  if (status === 429) {
    return 'Zu viele Anfragen in kurzer Zeit. Bitte 30 Sekunden warten und erneut versuchen.';
  }
  if (status >= 500) {
    return `Die Suche konnte gerade nicht antworten (Fehler ${status}). Bitte erneut versuchen.`;
  }
  if (status === 401 || status === 403) {
    return 'Anmeldung abgelaufen oder keine Berechtigung für diese Suche.';
  }
  return `Die Suche konnte die Anfrage nicht annehmen (Fehler ${status}).`;
}

export function newPortalSucheRequestId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'suche_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function portalSucheMarkedHits(
  hits: PortalSucheExploreHit[],
  markedKeys: readonly string[],
): PortalSucheExploreHit[] {
  const allow = new Set(markedKeys.map((key) => String(key || '').trim()).filter(Boolean));
  if (!allow.size) return [];
  return hits.filter((hit) => allow.has(hit.key));
}

/** Pin umschalten — Reihenfolge bleibt, Scroll/Re-Render darf die Auswahl nicht verlieren. */
export function portalSucheToggleMarkedKeys(
  prev: readonly string[],
  key: string,
): string[] {
  const nextKey = String(key || '').trim();
  if (!nextKey) return prev.slice();
  return prev.includes(nextKey) ? prev.filter((item) => item !== nextKey) : [...prev, nextKey];
}

export function portalSucheComposeButtonEnabled(markedCount: number, busy = false): boolean {
  return Number(markedCount) > 0 && !busy;
}

export function portalSucheComposeButtonLabel(markedCount: number): string {
  const n = Math.max(0, Number(markedCount) || 0);
  if (n < 1) return 'Zusammenfassen';
  return `${n} merken · Zusammenfassen`;
}

export function portalSucheBarComposeButtonLabel(chipCount: number): string {
  const n = Math.max(0, Number(chipCount) || 0);
  if (n < 1) return PORTAL_SUCHE_BAR_COMPOSE_LABEL;
  return `${n} · ${PORTAL_SUCHE_BAR_COMPOSE_LABEL}`;
}

export type PortalSucheQueryChip = {
  key: string;
  query: string;
  label: string;
  normId: string;
};

export type PortalSucheEnterAction = 'search' | 'pin' | 'compose';

/** Enter ohne Chip = Einzelsuche. Mit Chip + Text = Pin. Mit Chip + leer = gemeinsam suchen. */
export function portalSucheEnterAction(chipCount: number, query: string): PortalSucheEnterAction {
  const hasChips = Number(chipCount) > 0;
  const hasText = Boolean(trimmedQuery(query));
  if (!hasChips) return 'search';
  if (hasText) return 'pin';
  return 'compose';
}

export function portalSucheQueryChipFromInput(
  kind: PortalSucheKind,
  query: string,
): PortalSucheQueryChip | null {
  const q = trimmedQuery(query);
  if (!q) return null;
  const normId = kind === 'lex' ? portalSucheLexQueryToNormId(q) : '';
  const label = normId ? portalSucheNormIdToLabel(normId) : q;
  const key = normId || `q:${q.toLowerCase()}`;
  return { key, query: q, label, normId };
}

/** Pin hängt den Input an. Leerer Input = no-op, keine Suche, keine Liste. */
export function portalSuchePinQueryChip(
  prev: readonly PortalSucheQueryChip[],
  kind: PortalSucheKind,
  query: string,
): PortalSucheQueryChip[] {
  const chip = portalSucheQueryChipFromInput(kind, query);
  if (!chip) return prev.slice();
  if (prev.some((item) => item.key === chip.key)) return prev.slice();
  return [...prev, chip];
}

export function portalSucheRemoveQueryChip(
  prev: readonly PortalSucheQueryChip[],
  key: string,
): PortalSucheQueryChip[] {
  const nextKey = String(key || '').trim();
  if (!nextKey) return prev.slice();
  return prev.filter((item) => item.key !== nextKey);
}

export function portalSucheChipsToExploreHits(
  chips: readonly PortalSucheQueryChip[],
): PortalSucheExploreHit[] {
  return chips.map((chip) => ({
    key: chip.normId || chip.key,
    title: chip.label,
    paragraph: chip.label,
    short: '',
    risUrl: '',
    citeQuery: chip.query,
  }));
}

function portalSucheSourceMatchesChip(item: unknown, chip: PortalSucheQueryChip): boolean {
  const row = asRecord(item);
  if (!row) return false;
  const id = String(row.norm_id || row.normId || '').trim();
  if (id && chip.normId && portalSucheNormIdsEqual(chip.normId, id)) return true;
  if (id && portalSucheNormIdsEqual(chip.query, id)) return true;
  if (id && portalSucheNormIdsEqual(chip.label, id)) return true;
  if (id && portalSucheNormIdsEqual(chip.key, id)) return true;
  const title = String(row.title || '').toLowerCase();
  const q = chip.query.toLowerCase();
  if (!chip.normId && q.length >= 3 && title.includes(q)) return true;
  return false;
}

/**
 * Compose-Filter für Leisten-Chips: höchstens eine Source pro Chip, keine Extra-Norm.
 * Specimen 3 Chips → keine vierte.
 */
export function filterPortalSucheLexProofToMarkedChips(
  lexProof: unknown,
  chips: readonly PortalSucheQueryChip[],
): unknown {
  const rec = asRecord(lexProof);
  if (!rec || !chips.length) {
    if (!rec) return lexProof;
    return {
      ...rec,
      sources: [],
      norm_chain: Array.isArray(rec.norm_chain) ? [] : rec.norm_chain,
    };
  }
  const sources = Array.isArray(rec.sources) ? rec.sources : [];
  const used = new Set<number>();
  const filteredSources: unknown[] = [];
  for (const chip of chips) {
    const matchIndex = sources.findIndex((item, idx) => {
      if (used.has(idx)) return false;
      return portalSucheSourceMatchesChip(item, chip);
    });
    if (matchIndex >= 0) {
      used.add(matchIndex);
      filteredSources.push(sources[matchIndex]);
    }
  }
  const next: Record<string, unknown> = { ...rec, sources: filteredSources };
  if (Array.isArray(rec.norm_chain)) {
    const allow = new Set(
      filteredSources
        .map((item) => String(asRecord(item)?.norm_id || asRecord(item)?.normId || '').trim())
        .filter(Boolean),
    );
    next.norm_chain = rec.norm_chain.filter((item) => {
      const id = String(asRecord(item)?.norm_id || '').trim();
      return Boolean(id && allow.has(id));
    });
  }
  return next;
}

export function filterPortalSucheJudProofToMarkedChips(
  judProof: unknown,
  chips: readonly PortalSucheQueryChip[],
): unknown {
  const rec = asRecord(judProof);
  if (!rec || !chips.length) {
    if (!rec) return judProof;
    return { ...rec, cases: [] };
  }
  const cases = Array.isArray(rec.cases) ? rec.cases : [];
  const used = new Set<number>();
  const filtered: unknown[] = [];
  for (const chip of chips) {
    const q = chip.query.toLowerCase();
    const matchIndex = cases.findIndex((item, idx) => {
      if (used.has(idx)) return false;
      const row = asRecord(item);
      if (!row) return false;
      const gz = String(row.geschaeftszahl || '').trim().toLowerCase();
      const caseId = String(row.case_id || row.caseId || '').trim().toLowerCase();
      const leitsatz = String(row.leitsatz || '').trim().toLowerCase();
      return (
        (gz && (gz === q || gz === chip.key.toLowerCase())) ||
        (caseId && (caseId === q || caseId === chip.key.toLowerCase())) ||
        (q.length >= 3 && leitsatz.includes(q))
      );
    });
    if (matchIndex >= 0) {
      used.add(matchIndex);
      filtered.push(cases[matchIndex]);
    }
  }
  return { ...rec, cases: filtered };
}

export function portalSucheMergeMarkedHits(
  chipHits: readonly PortalSucheExploreHit[],
  resultHits: readonly PortalSucheExploreHit[],
): PortalSucheExploreHit[] {
  const out: PortalSucheExploreHit[] = [];
  const seen = new Set<string>();
  for (const hit of [...chipHits, ...resultHits]) {
    const key = String(hit.key || '').trim();
    if (!key || seen.has(key)) continue;
    seen.add(key);
    out.push(hit);
  }
  return out;
}

export function buildPortalSucheMarkedLexChatInput(
  selected: PortalSucheExploreHit[],
): string | null {
  if (!selected.length) return null;
  const labels = selected
    .map((hit) => String(hit.citeQuery || hit.paragraph || '').trim())
    .filter(Boolean);
  if (!labels.length) return null;
  return (
    `${PORTAL_SUCHE_LEX_PREFIX}` +
    `Bitte nur nachschlagen: ${labels.join(', ')}. ` +
    PORTAL_SUCHE_MARKED_LEX_TAIL
  );
}

/** Compose-HTTP nur für die Markierung. Leere Auswahl → null (kein Call, kein Halluzinations-Text). */
export function buildPortalSucheMarkedWebhookBody(opts: {
  kind: PortalSucheKind;
  selected: PortalSucheExploreHit[];
  extraBody?: Record<string, unknown> | null;
  requestId: string;
}): Record<string, unknown> | null {
  if (!opts.selected.length) return null;
  const labels = opts.selected
    .map((hit) => String(hit.citeQuery || hit.paragraph || '').trim())
    .filter(Boolean);
  if (!labels.length) return null;
  if (opts.kind === 'jud') {
    return buildPortalSucheWebhookBody({
      kind: 'jud',
      query: labels.join(', '),
      extraBody: opts.extraBody,
      requestId: opts.requestId,
    });
  }
  const chatInput = buildPortalSucheMarkedLexChatInput(opts.selected);
  if (!chatInput) return null;
  const body: Record<string, unknown> = {
    chatInput,
    history: [],
    mode: PORTAL_SUCHE_MODE,
    request_id: opts.requestId,
    stream: true,
    preferStream: true,
    intent: 'rechtsfrage',
    chip_action: PORTAL_SUCHE_CHIP_PARAGRAPH,
    ...portalSucheTenantExtras(opts.extraBody),
  };
  for (const key of PORTAL_SUCHE_STRIP_BODY_KEYS) {
    delete body[key];
  }
  return body;
}

export function filterPortalSucheLexProofToMarkedIds(
  lexProof: unknown,
  markedIds: readonly string[],
): unknown {
  const allow = new Set(
    markedIds.map((id) => portalSucheCanonNormId(id) || String(id || '').trim()).filter(Boolean),
  );
  const rec = asRecord(lexProof);
  if (!rec || !allow.size) {
    if (!rec) return lexProof;
    return { ...rec, sources: [], norm_chain: Array.isArray(rec.norm_chain) ? [] : rec.norm_chain };
  }
  const sources = Array.isArray(rec.sources) ? rec.sources : [];
  const filteredSources = sources.filter((item) => {
    const row = asRecord(item);
    const id = String(row?.norm_id || row?.normId || '').trim();
    const canon = portalSucheCanonNormId(id) || id;
    return Boolean(canon && allow.has(canon));
  });
  const next: Record<string, unknown> = { ...rec, sources: filteredSources };
  if (Array.isArray(rec.norm_chain)) {
    next.norm_chain = rec.norm_chain.filter((item) => {
      const row = asRecord(item);
      const id = String(row?.norm_id || '').trim();
      const canon = portalSucheCanonNormId(id) || id;
      return Boolean(canon && allow.has(canon));
    });
  }
  return next;
}

export function filterPortalSucheJudProofToMarkedKeys(
  judProof: unknown,
  markedKeys: readonly string[],
): unknown {
  const allow = new Set(markedKeys.map((id) => String(id || '').trim()).filter(Boolean));
  const rec = asRecord(judProof);
  if (!rec || !allow.size) {
    if (!rec) return judProof;
    return { ...rec, cases: [] };
  }
  const cases = Array.isArray(rec.cases) ? rec.cases : [];
  const filtered = cases.filter((item) => {
    const row = asRecord(item);
    if (!row) return false;
    const gz = String(row.geschaeftszahl || '').trim();
    const caseId = String(row.case_id || row.caseId || '').trim();
    return (gz && allow.has(gz)) || (caseId && allow.has(caseId));
  });
  return { ...rec, cases: filtered };
}

export function portalSucheMarkedSourceIds(lexProof: unknown): string[] {
  const rec = asRecord(lexProof);
  const sources = Array.isArray(rec?.sources) ? rec!.sources : [];
  const ids: string[] = [];
  const seen = new Set<string>();
  for (const item of sources) {
    const row = asRecord(item);
    const id = String(row?.norm_id || row?.normId || '').trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    ids.push(id);
  }
  return ids;
}

export type PortalSucheComposeBlock = {
  key: string;
  paragraph: string;
  status: 'hit' | 'skip';
  title: string;
  body: string;
  risUrl: string;
  /** Nur wenn die Quelle `valid_from` schon mitbringt. */
  validFrom?: string;
  /** Einordnung aus dem Lauf, wenn sie kein RIS-Schnipsel ist. */
  summary?: string;
};

export type PortalSucheComposeSource = {
  norm_id?: string;
  title?: string;
  fragment_text?: string;
  ris_url?: string;
  risUrl?: string;
  valid_from?: string;
};

/** JUD-Fall für Compose-Blöcke — ohne Import von judicatureProof (Gate transpiliert isoliert). */
export type PortalSucheComposeJudCase = {
  case_id?: string;
  geschaeftszahl?: string;
  leitsatz?: string;
  kernsaetze?: string[];
  rechtssaetze?: string[];
  source_url?: string;
};

function portalSucheSourceMatchesHit(
  src: PortalSucheComposeSource,
  hit: PortalSucheExploreHit,
): boolean {
  const id = String(src.norm_id || '').trim();
  if (!id) return false;
  return (
    portalSucheNormIdsEqual(hit.key, id) ||
    portalSucheNormIdsEqual(hit.citeQuery, id) ||
    portalSucheNormIdsEqual(hit.paragraph, id)
  );
}

function portalSucheJudCaseMatchesHit(
  cse: PortalSucheComposeJudCase,
  hit: PortalSucheExploreHit,
): boolean {
  const gz = String(cse.geschaeftszahl || '').trim();
  const id = String(cse.case_id || '').trim();
  const key = String(hit.key || '').trim();
  const q = String(hit.citeQuery || hit.paragraph || '').trim();
  if (id && (id === key || id === q)) return true;
  if (!gz) return false;
  const gzLow = gz.toLowerCase();
  return gz === key || gz === q || gzLow === key.toLowerCase() || gzLow === q.toLowerCase();
}

/**
 * Ein Block je Chip: RIS-Hit oder ehrlicher Skip.
 * Specimen 24f still dropped — kein dritter Chip nur als Überschrift.
 */
export function portalSucheComposeBlocks(opts: {
  selected: PortalSucheExploreHit[];
  filteredSources?: PortalSucheComposeSource[];
  judCases?: PortalSucheComposeJudCase[];
  /** Einordnung je Chip aus dem schon gelaufenen Antworttext. Kein zweiter LEX-Call. */
  summariesByKey?: Record<string, string>;
}): PortalSucheComposeBlock[] {
  const sources = opts.filteredSources || [];
  const cases = opts.judCases || [];
  return opts.selected.map((hit) => {
    const src = sources.find((item) => portalSucheSourceMatchesHit(item, hit));
    const cse = cases.find((item) => portalSucheJudCaseMatchesHit(item, hit));
    const core = cse
      ? (Array.isArray(cse.kernsaetze) && cse.kernsaetze.length
          ? cse.kernsaetze
          : Array.isArray(cse.rechtssaetze)
            ? cse.rechtssaetze
            : []
        )
          .map((line) => String(line || '').trim())
          .find(Boolean)
      : '';
    const fragment = String(src?.fragment_text || core || hit.wortlaut || hit.short || '').trim();
    const risUrl = String(
      src?.ris_url || src?.risUrl || cse?.source_url || hit.risUrl || '',
    ).trim();
    const title = String(src?.title || cse?.leitsatz || hit.title || '').trim();
    const validFrom = String(src?.valid_from || '').trim();
    const summary =
      portalSucheRunSummaryText(opts.summariesByKey?.[hit.key] || '', [fragment]) || undefined;
    if (fragment) {
      return {
        key: hit.key,
        paragraph: hit.paragraph,
        status: 'hit' as const,
        title,
        body: fragment,
        risUrl: risUrl.startsWith('http') ? risUrl : '',
        validFrom,
        summary,
      };
    }
    return {
      key: hit.key,
      paragraph: hit.paragraph,
      status: 'skip' as const,
      title: '',
      body: PORTAL_SUCHE_MARKED_SKIP,
      risUrl: '',
    };
  });
}

/** Ein LEX-Call je Chip — sonst routet LEXCORE nur die erste Cite-Domain (ABGB → Mietrecht, LFG fällt still). */
export function buildPortalSucheMarkedChipWebhookBodies(opts: {
  kind: PortalSucheKind;
  selected: PortalSucheExploreHit[];
  extraBody?: Record<string, unknown> | null;
}): Array<{ key: string; body: Record<string, unknown> }> {
  const out: Array<{ key: string; body: Record<string, unknown> }> = [];
  for (const hit of opts.selected) {
    const body = buildPortalSucheMarkedWebhookBody({
      kind: opts.kind,
      selected: [hit],
      extraBody: opts.extraBody,
      requestId: newPortalSucheRequestId(),
    });
    if (!body) continue;
    out.push({ key: hit.key, body });
  }
  return out;
}

export function mergePortalSucheLexProofs(proofs: unknown[]): unknown {
  const recs = proofs.map(asRecord).filter(Boolean) as Record<string, unknown>[];
  if (!recs.length) return null;
  const sources: unknown[] = [];
  const seen = new Set<string>();
  for (const rec of recs) {
    const list = Array.isArray(rec.sources) ? rec.sources : [];
    for (const item of list) {
      const id = String(asRecord(item)?.norm_id || asRecord(item)?.normId || '').trim();
      const canon = portalSucheCanonNormId(id) || id;
      if (!canon || seen.has(canon)) continue;
      seen.add(canon);
      sources.push(item);
    }
  }
  return { ...recs[0], sources };
}

/**
 * Einordnung aus dem schon gelieferten Antworttext.
 * RIS-Schnipsel wird herausgenommen. Bleibt danach kein Satz, ist das Feld leer —
 * dann Titel/Kopf, kein erfundener Rechtstext.
 */
export function portalSucheRunSummaryText(
  modelText: string,
  fragments: readonly string[],
): string {
  let t = String(modelText || '')
    .replace(/\n*\[LEX:[^\]]+\]\s*/gi, ' ')
    .replace(/Hier der verifizierte Wortlaut:\s*/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (!t) return '';
  for (const frag of fragments) {
    const needle = String(frag || '').replace(/\s+/g, ' ').trim();
    if (needle.length < 32) continue;
    const probe = needle.slice(0, Math.min(80, needle.length));
    if (!probe || !t.includes(probe)) continue;
    t = t
      .split(probe)
      .join(' ')
      .replace(/\s+/g, ' ')
      .replace(/^[\s,.;:–-]+|[\s,.;:–-]+$/g, '')
      .trim();
  }
  if (t.length < 24) return '';
  if (t.length > 900) return `${t.slice(0, 899).trimEnd()}…`;
  return t;
}

/**
 * LLM-Text nur wenn er kein RIS-Schnipsel wiederholt (kein eigener Compose-Endpoint).
 * Zu lang oder enthält fragment_text → leer, dann extraktiver Titel-Kopf.
 */
export function portalSucheTakeExtractiveOrientationModelText(
  modelText: string,
  fragments: readonly string[],
): string {
  const t = String(modelText || '').replace(/\s+/g, ' ').trim();
  if (!t || t.length > 720) return '';
  for (const frag of fragments) {
    const needle = String(frag || '').replace(/\s+/g, ' ').trim();
    if (needle.length < 32) continue;
    const probe = needle.slice(0, Math.min(80, needle.length));
    if (t.includes(probe)) return '';
  }
  return t;
}

/** Langer Titel, der den RIS-Absatz wiederholt — nicht in die Orientierung. Kurze Überschriften bleiben. */
function portalSucheTitleIsRisVolltext(title: string, body: string): boolean {
  const t = String(title || '').replace(/\s+/g, ' ').trim();
  const b = String(body || '').replace(/\s+/g, ' ').trim();
  if (!t || !b || t.length < 40) return false;
  if (t === b) return true;
  if (b.length >= 40 && (t.includes(b.slice(0, 48)) || b.includes(t))) return true;
  return false;
}

const PORTAL_SUCHE_CITE_RE = /§\s*\d+[a-z]?(?:\s+[A-ZÄÖÜ][A-Za-zÄÖÜäöü.\-]{1,20})?/g;

function portalSucheCiteGrounded(cite: string, source: string): boolean {
  const compact = cite.replace(/\s+/g, ' ').trim();
  const numMatch = compact.match(/§\s*(\d+[a-z]?)/i);
  if (!numMatch) return false;
  const num = numMatch[1];
  const escaped = num.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const numInSource =
    new RegExp(`§\\s*${escaped}\\b`, 'i').test(source) ||
    new RegExp(`-${escaped}\\b`, 'i').test(source);
  if (!numInSource) return false;
  const lawMatch = compact.match(/§\s*\d+[a-z]?\s+([A-ZÄÖÜ][A-Za-zÄÖÜäöü.\-]{1,20})/);
  if (!lawMatch) return true;
  return source.toLowerCase().includes(lawMatch[1].toLowerCase());
}

function portalSucheDropHeuristicSentences(text: string): string {
  return text
    .split(/(?<=[.!?])\s+/)
    .filter(
      (sentence) =>
        !/\d+\s*(%|Prozent)\b/i.test(sentence) && !/wahrscheinlichkeit/i.test(sentence),
    )
    .join(' ')
    .trim();
}

/**
 * Klasse SUCHE_ORIENTATION_ENTITLED_OR_HEAD.
 * Ohne Freischaltung leer. Mit Freischaltung nur Text, dessen Paragraphen
 * in der Quelle dieses Laufs stehen, ohne Beispiel-Norm bei leerer Quelle
 * und ohne Heuristik als Prozent oder Wahrscheinlichkeit.
 */
export function portalSucheOrientationModelText(opts: {
  modelText: string;
  entitled: boolean;
  sourceText: string;
}): string {
  if (opts.entitled !== true) return '';
  let t = String(opts.modelText || '').replace(/\s+/g, ' ').trim();
  if (!t) return '';
  t = portalSucheDropHeuristicSentences(t);
  if (!t || t.length < 24) return '';
  const source = String(opts.sourceText || '');
  const cites = t.match(PORTAL_SUCHE_CITE_RE) || [];
  for (const cite of cites) {
    if (!portalSucheCiteGrounded(cite, source)) return '';
  }
  if (t.length > 900) return `${t.slice(0, 899).trimEnd()}…`;
  return t;
}

export type PortalSucheModelGate = {
  entitled?: boolean;
  sourceText?: string;
};

/**
 * Kurze Zusammenfassung über dem Wortlaut.
 * Titel/Kopf, sonst ein Satz aus dem Paragraphen — nie der RIS-Absatz selbst.
 * Modelltext nur mit Freischaltung und Quelle dieses Laufs.
 */
export function portalSucheCardSummary(
  title: string,
  paragraph: string,
  wortlaut: string,
  runText = '',
  gate?: PortalSucheModelGate,
): string {
  const sourceText = gate?.sourceText ?? [paragraph, title, wortlaut].filter(Boolean).join('\n');
  const run = portalSucheOrientationModelText({
    modelText: portalSucheRunSummaryText(runText, [wortlaut]),
    entitled: gate?.entitled === true,
    sourceText,
  });
  if (run) return run;
  const head = portalSucheHeadExplanation(title, paragraph, wortlaut);
  const para = String(paragraph || '').replace(/\s+/g, ' ').trim();
  if (head) {
    const trimmed = head.replace(/[.]+$/, '');
    if (para) return `${para} — ${PORTAL_SUCHE_MARKED_ORIENTATION_FROM_HEAD}: ${trimmed}.`;
    return `${trimmed}.`;
  }
  if (para && String(wortlaut || '').trim()) {
    return `${para} ${PORTAL_SUCHE_MARKED_ORIENTATION_HIT_TAIL}`;
  }
  return '';
}

/** Kurze Erklärung nur aus Titel/Kopf. Kein Gutachten, kein zweites Mal der Wortlaut. */
export function portalSucheHeadExplanation(title: string, paragraph: string, wortlaut: string): string {
  const head = String(title || '').replace(/\s+/g, ' ').trim();
  const para = String(paragraph || '').replace(/\s+/g, ' ').trim();
  const body = String(wortlaut || '').replace(/\s+/g, ' ').trim();
  if (!head || head === para) return '';
  if (portalSucheTitleIsRisVolltext(head, body)) return '';
  if (body && head.length >= 24 && (body === head || body.includes(head))) return '';
  if (head.length > 220) return `${head.slice(0, 219).trimEnd()}…`;
  return head;
}

/** Ein Satz je Chip: Titel/Kopf, kein RIS-Volltext, kein Fake-Gutachten. */
export function portalSucheOrientationSentence(block: PortalSucheComposeBlock): string {
  const para = String(block.paragraph || '').trim();
  if (!para) return '';
  if (block.status !== 'hit') {
    return `${para}: ${PORTAL_SUCHE_MARKED_ORIENTATION_SKIP_TAIL}`;
  }
  const title = String(block.title || '').trim();
  const body = String(block.body || '').trim();
  if (title && title !== para && !portalSucheTitleIsRisVolltext(title, body)) {
    const clipped = title.length > 140 ? `${title.slice(0, 139).trimEnd()}…` : title;
    const trimmed = clipped.replace(/[.]+$/, '');
    return `${para} — ${PORTAL_SUCHE_MARKED_ORIENTATION_FROM_HEAD}: ${trimmed}.`;
  }
  const shortHead = body.replace(/[.]+$/, '').trim();
  if (shortHead && shortHead !== para && shortHead.length >= 3 && shortHead.length < 24) {
    return `${para} — ${PORTAL_SUCHE_MARKED_ORIENTATION_FROM_HEAD}: ${shortHead}.`;
  }
  return `${para} ${PORTAL_SUCHE_MARKED_ORIENTATION_HIT_TAIL}`;
}

/** Compose-Haystack (Orientierung + Block-Bodies) — Gate gegen 2× dasselbe Schnipsel. */
export function portalSucheComposeViewHaystack(
  orientation: string,
  blocks: readonly PortalSucheComposeBlock[],
): string {
  return [orientation, ...blocks.map((block) => block.body)].join('\n\n');
}

export function portalSucheSnippetOccursTwice(haystack: string, snippet: string): boolean {
  const needle = String(snippet || '').replace(/\s+/g, ' ').trim();
  if (needle.length < 24) return false;
  const hay = String(haystack || '').replace(/\s+/g, ' ');
  const first = hay.indexOf(needle);
  if (first < 0) return false;
  return hay.indexOf(needle, first + needle.length) >= 0;
}

/**
 * Orientierung nur zu den markierten Chips: 2–4 Sätze aus Titeln/Köpfen, kein RIS-Volltext.
 * § 9 RAO steht in der Pfad-Klappe, nicht in der Hauptfläche.
 * Polar: lieber ehrlich kurz als 2× dasselbe Schnipsel. Kein Extra-Join, kein Fake-Gutachten.
 */
export function buildPortalSucheMarkedOrientation(opts: {
  selected: PortalSucheExploreHit[];
  filteredSources?: PortalSucheComposeSource[];
  judCases?: PortalSucheComposeJudCase[];
  modelText?: string;
  hasFilteredRis?: boolean;
  /** true nur wenn PORTAL_BAUSTEIN_FREISCHALTUNG für ARKO auf an steht. */
  entitled?: boolean;
}): string {
  if (!opts.selected.length) return PORTAL_SUCHE_MARKED_EMPTY_HINT;
  const blocks = portalSucheComposeBlocks({
    selected: opts.selected,
    filteredSources: opts.filteredSources,
    judCases: opts.judCases,
  });
  const fragments = blocks
    .filter((block) => block.status === 'hit')
    .map((block) => block.body)
    .filter(Boolean);
  const sourceText = [
    ...blocks.flatMap((block) => [block.paragraph, block.title, block.body, block.key]),
    ...(opts.filteredSources || []).flatMap((src) => [src.norm_id, src.title, src.fragment_text]),
    ...(opts.judCases || []).flatMap((cse) => [cse.geschaeftszahl, cse.case_id, cse.leitsatz]),
  ]
    .filter(Boolean)
    .join('\n');
  const gated = portalSucheOrientationModelText({
    modelText: opts.modelText || '',
    entitled: opts.entitled === true,
    sourceText,
  });
  const model = portalSucheTakeExtractiveOrientationModelText(gated, fragments);
  if (model) return model;
  const sentences = blocks.map(portalSucheOrientationSentence).filter(Boolean).slice(0, 4);
  return sentences.join(' ');
}

/** Anzeige der Compose-Orientierung. Ohne Freischaltung bleibt der Kopf aus den Blöcken. */
export function portalSucheVisibleOrientation(opts: {
  text: string;
  entitled: boolean;
  blocks: readonly PortalSucheComposeBlock[];
}): string {
  const head = opts.blocks.map(portalSucheOrientationSentence).filter(Boolean).slice(0, 4).join(' ');
  if (opts.entitled !== true) return head;
  const sourceText = opts.blocks
    .flatMap((block) => [block.paragraph, block.title, block.body, block.key])
    .filter(Boolean)
    .join('\n');
  const model = portalSucheTakeExtractiveOrientationModelText(
    portalSucheOrientationModelText({
      modelText: opts.text,
      entitled: true,
      sourceText,
    }),
    opts.blocks.filter((block) => block.status === 'hit').map((block) => block.body).filter(Boolean),
  );
  return model || head;
}

export type PortalSucheComposePathChip = {
  key: string;
  label: string;
  status: 'hit' | 'skip';
  /** Abgerufene Quelle (norm_id / JUD-Id) — nie Token, nie Gewichte. */
  source: string;
};

export type PortalSucheComposePath = {
  kind: typeof PORTAL_SUCHE_MARKED_PATH_KIND;
  disclaimer: typeof PORTAL_SUCHE_MARKED_DISCLAIMER;
  pinnedLabel: string;
  composeClose: typeof PORTAL_SUCHE_MARKED_PATH_COMPOSE_CLOSE;
  chips: PortalSucheComposePathChip[];
  /** Eine Zeile pro Schritt, gleiche Tiefe wie die ARKO-Spur. */
  steps: string[];
};

function portalSuchePathSourceLabel(opts: {
  hit: PortalSucheExploreHit;
  block?: PortalSucheComposeBlock;
  sources: PortalSucheComposeSource[];
  cases: PortalSucheComposeJudCase[];
}): string {
  if (opts.block?.status !== 'hit') return PORTAL_SUCHE_MARKED_PATH_SOURCE_NORM;
  const src = opts.sources.find((item) => portalSucheSourceMatchesHit(item, opts.hit));
  const cse = opts.cases.find((item) => portalSucheJudCaseMatchesHit(item, opts.hit));
  const lexId = String(src?.norm_id || '').trim();
  if (lexId) return `${PORTAL_SUCHE_MARKED_PATH_SOURCE_LEX} · ${lexId}`;
  const judId = String(cse?.geschaeftszahl || cse?.case_id || '').trim();
  if (judId) return `${PORTAL_SUCHE_MARKED_PATH_SOURCE_JUD} · ${judId}`;
  if (cse) return PORTAL_SUCHE_MARKED_PATH_SOURCE_JUD;
  return opts.block.risUrl
    ? PORTAL_SUCHE_MARKED_PATH_SOURCE_LEX
    : PORTAL_SUCHE_MARKED_PATH_SOURCE_NORM;
}

/**
 * Pfad nur aus angehefteten Chips: je Chip LEX-Hit oder Skip.
 * Extra-Normen, die nicht abgerufen/zugeordnet wurden, erscheinen nicht.
 * Keine Modell-Gewichte, kein Token-Log.
 */
export function buildPortalSucheComposePath(opts: {
  selected: PortalSucheExploreHit[];
  blocks?: readonly PortalSucheComposeBlock[];
  filteredSources?: PortalSucheComposeSource[];
  judCases?: PortalSucheComposeJudCase[];
}): PortalSucheComposePath {
  const sources = opts.filteredSources || [];
  const cases = opts.judCases || [];
  const blocks =
    opts.blocks && opts.blocks.length
      ? opts.blocks
      : portalSucheComposeBlocks({
          selected: opts.selected,
          filteredSources: sources,
          judCases: cases,
        });
  const byKey = new Map(blocks.map((block) => [block.key, block]));
  const chips: PortalSucheComposePathChip[] = opts.selected.map((hit) => {
    const block = byKey.get(hit.key);
    const status = block?.status === 'hit' ? 'hit' : 'skip';
    return {
      key: hit.key,
      label: String(hit.paragraph || hit.citeQuery || hit.key).trim(),
      status,
      source: portalSuchePathSourceLabel({ hit, block, sources, cases }),
    };
  });
  const pinned = chips
    .map((chip) => chip.label)
    .filter(Boolean)
    .join(', ');
  const path: PortalSucheComposePath = {
    kind: PORTAL_SUCHE_MARKED_PATH_KIND,
    disclaimer: PORTAL_SUCHE_MARKED_DISCLAIMER,
    pinnedLabel: `${PORTAL_SUCHE_MARKED_PATH_PINNED}: ${pinned}`,
    composeClose: PORTAL_SUCHE_MARKED_PATH_COMPOSE_CLOSE,
    chips,
    steps: [],
  };
  path.steps = portalSucheComposePathSteps(path);
  return path;
}

/** Spur wie ARKO: Frage, Schritt, Treffer/Quelle, was eingeflossen ist. Kein Auto-Join. */
export function portalSucheComposePathSteps(
  path: Pick<PortalSucheComposePath, 'pinnedLabel' | 'composeClose' | 'chips'>,
): string[] {
  const asked = path.pinnedLabel.replace(/^Angeheftet:\s*/, '').trim();
  const lines = [`Eingeordnet: ${asked || 'die Suche'}.`, 'Schritt Normen: nachgeschlagen.'];
  const jud = path.chips.some((chip) =>
    chip.source.startsWith(PORTAL_SUCHE_MARKED_PATH_SOURCE_JUD),
  );
  if (jud) lines.push('Schritt Judikatur: die gewählte Suche nachgesehen.');
  for (const chip of path.chips) {
    const status = chip.status === 'hit' ? PORTAL_SUCHE_MARKED_PATH_HIT : PORTAL_SUCHE_MARKED_PATH_SKIP_STATUS;
    lines.push(`Nachgeschlagen ${chip.label}: ${status}. Quelle: ${chip.source}.`);
  }
  const flowed = path.chips.filter((chip) => chip.status === 'hit').map((chip) => chip.label);
  const skipped = path.chips.filter((chip) => chip.status === 'skip').map((chip) => chip.label);
  lines.push(
    flowed.length
      ? `In die Antwort eingeflossen: ${flowed.join(', ')}.`
      : 'In die Antwort eingeflossen: keine belegte Norm.',
  );
  lines.push(
    skipped.length
      ? `Nicht eingeflossen: ${skipped.join(', ')}. ${path.composeClose}`
      : `Nicht eingeflossen: ${path.composeClose}`,
  );
  return lines;
}

export function portalSucheComposeSourcesFromLexProof(lexProof: unknown): PortalSucheComposeSource[] {
  const rec = asRecord(lexProof);
  const sources = Array.isArray(rec?.sources) ? rec.sources : [];
  const out: PortalSucheComposeSource[] = [];
  for (const item of sources) {
    const row = asRecord(item);
    if (!row) continue;
    const norm_id = String(row.norm_id || row.normId || '').trim();
    if (!norm_id) continue;
    out.push({
      norm_id,
      title: String(row.title || '') || undefined,
      fragment_text: String(row.fragment_text || row.fragmentText || '') || undefined,
      ris_url: String(row.ris_url || row.risUrl || '') || undefined,
      valid_from: String(row.valid_from || row.validFrom || '').trim() || undefined,
    });
  }
  return out;
}

/**
 * Pfad für die Fläche mit dem AI-Text (Normen-Karte oder Markierte Suche).
 * Nur angeheftete Chips bzw. die konkrete Einzelsuche — keine Extra-Norm aus lexProof.
 */
export function buildPortalSucheAnswerPath(opts: {
  kind: PortalSucheKind;
  query?: string;
  chips?: readonly PortalSucheQueryChip[];
  selected?: readonly PortalSucheExploreHit[];
  blocks?: readonly PortalSucheComposeBlock[];
  filteredSources?: PortalSucheComposeSource[];
  judCases?: PortalSucheComposeJudCase[];
}): PortalSucheComposePath | null {
  const selected = opts.selected?.length
    ? opts.selected.slice()
    : portalSucheChipsToExploreHits(
        opts.chips?.length
          ? opts.chips
          : (() => {
              const chip = portalSucheQueryChipFromInput(opts.kind, opts.query || '');
              return chip ? [chip] : [];
            })(),
      );
  if (!selected.length) return null;
  return buildPortalSucheComposePath({
    selected,
    blocks: opts.blocks,
    filteredSources: opts.filteredSources,
    judCases: opts.judCases,
  });
}

export function portalSucheComposePathChipCount(path: PortalSucheComposePath | null | undefined): number {
  return Array.isArray(path?.chips) ? path!.chips.length : 0;
}

/** Extra-Norm nur wenn eine Pfad-Zeile nicht zu den angehefteten Chips gehört. */
export function portalSucheComposePathHasExtraNorm(
  path: PortalSucheComposePath,
  selected: readonly PortalSucheExploreHit[],
): boolean {
  const allow = new Set(selected.map((hit) => String(hit.key || '').trim()).filter(Boolean));
  if (!allow.size) return path.chips.length > 0;
  return path.chips.some((chip) => !allow.has(chip.key));
}

/** Nur abgerufene Hit-Quellen — Skip und fremde IDs zählen nicht. */
export function portalSucheComposePathRetrievedIds(path: PortalSucheComposePath): string[] {
  const ids: string[] = [];
  const seen = new Set<string>();
  for (const chip of path.chips) {
    if (chip.status !== 'hit') continue;
    const m = String(chip.source || '').match(/\b([A-ZÄÖÜ][A-ZÄÖÜ0-9.-]{1,20}-\d{1,4}[A-Z]?)\b/i);
    const id = m?.[1] ? portalSucheCanonNormId(m[1]) : '';
    if (!id || seen.has(id)) continue;
    seen.add(id);
    ids.push(id);
  }
  return ids;
}

/** Labor-Demo: letzte Chips + Compose über Reload. Kein PB, keine PII, nicht in der URL. */
export const PORTAL_SUCHE_PERSIST_VERSION = 1;
export const PORTAL_SUCHE_PERSIST_PREFIX = 'portal-suche-s5';
export const PORTAL_SUCHE_PERSIST_MAX_CHIPS = 24;
export const PORTAL_SUCHE_PERSIST_MAX_SOURCES = 16;
export const PORTAL_SUCHE_PERSIST_MAX_CASES = 12;
export const PORTAL_SUCHE_PERSIST_MAX_TEXT = 240;
export const PORTAL_SUCHE_PERSIST_MAX_ORIENTATION = 1200;
export const PORTAL_SUCHE_PERSIST_MAX_BODY = 12_000;
export const PORTAL_SUCHE_PERSIST_MAX_JSON = 120_000;

export type PortalSuchePersistStore = {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
};

export type PortalSuchePersistedCompose = {
  orientation: string;
  blocks: PortalSucheComposeBlock[];
  path: PortalSucheComposePath;
};

export type PortalSuchePersistedView = 'search' | 'compose';

export type PortalSuchePersistedSource = {
  norm_id: string;
  title: string;
  fragment_text: string;
  ris_url: string;
};

export type PortalSuchePersistedCase = {
  case_id: string;
  geschaeftszahl: string;
  leitsatz: string;
  source_url: string;
};

/** LEX/JUD-Einfachsuche — Query, Treffer, Normen-Karte. Kein Chip-Zwang. */
export type PortalSuchePersistedSearch = {
  mode: PortalSucheMode;
  query: string;
  text: string;
  sources: PortalSuchePersistedSource[];
  cases: PortalSuchePersistedCase[];
};

export type PortalSuchePersistedState = {
  v: typeof PORTAL_SUCHE_PERSIST_VERSION;
  kind: PortalSucheKind;
  query: string;
  view: PortalSuchePersistedView;
  chips: PortalSucheQueryChip[];
  search: PortalSuchePersistedSearch | null;
  compose: PortalSuchePersistedCompose | null;
};

export function emptyPortalSuchePersistedState(): PortalSuchePersistedState {
  return {
    v: PORTAL_SUCHE_PERSIST_VERSION,
    kind: 'lex',
    query: '',
    view: 'search',
    chips: [],
    search: null,
    compose: null,
  };
}

export function portalSuchePersistIsEmpty(state: PortalSuchePersistedState | null | undefined): boolean {
  if (!state) return true;
  return (
    !state.chips.length &&
    !state.compose &&
    !state.search &&
    !String(state.query || '').trim()
  );
}

/** Nur customerId/Sitz — nie E-Mail, nie Aktenname. */
export function portalSuchePersistSeatId(extraBody?: Record<string, unknown> | null): string {
  const raw =
    extraBody && typeof extraBody === 'object' && typeof extraBody.customerId === 'string'
      ? extraBody.customerId
      : '';
  return raw
    .trim()
    .replace(/[^a-zA-Z0-9_-]/g, '_')
    .slice(0, 80);
}

export function portalSuchePersistStorageKey(seatId?: string | null): string {
  const uid = typeof seatId === 'string' ? seatId.trim() : '';
  return uid
    ? `${PORTAL_SUCHE_PERSIST_PREFIX}:u:${uid}`
    : `${PORTAL_SUCHE_PERSIST_PREFIX}:local`;
}

/** Renderfehler darf den gespeicherten Stand nicht beim nächsten Klick wieder auslösen. */
export function clearPortalSuchePersist(
  seatId?: string | null,
  store?: PortalSuchePersistStore | null,
): void {
  const storage = store === undefined ? defaultPortalSuchePersistStore() : store;
  if (!storage) return;
  try {
    storage.removeItem(portalSuchePersistStorageKey(seatId));
  } catch {
    /* privater Modus */
  }
}

function clipPortalSuchePersistText(raw: unknown, max: number): string {
  return String(raw ?? '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, max);
}

/** Wortlaut behält Absätze. Kein Zusammenziehen zu einer Zeile. */
function clipPortalSuchePersistBody(raw: unknown, max: number): string {
  return String(raw ?? '')
    .replace(/\r\n/g, '\n')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
    .slice(0, max);
}

function portalSuchePersistSafeBody(raw: unknown, max: number): string {
  const text = clipPortalSuchePersistBody(raw, max);
  if (!text) return '';
  if (portalSuchePersistLooksLikePii(text) || portalSuchePersistLooksLikeUrlDump(text)) return '';
  return text;
}

function portalSuchePersistLooksLikePii(text: string): boolean {
  const t = String(text || '');
  if (!t) return false;
  if (t.includes('@')) return true;
  return /\b\d{3,}[\s./-]?\d{3,}[\s./-]?\d{3,}\b/.test(t);
}

function portalSuchePersistLooksLikeUrlDump(text: string): boolean {
  const t = String(text || '');
  if (!t) return false;
  return /portal(?:-dev|-slot)?-labor\.arkorbit|\/webhook\/|localhost|127\.0\.0\.1/i.test(t);
}

function portalSuchePersistSafeText(raw: unknown, max: number): string {
  const text = clipPortalSuchePersistText(raw, max);
  if (!text) return '';
  if (portalSuchePersistLooksLikePii(text) || portalSuchePersistLooksLikeUrlDump(text)) return '';
  return text;
}

function portalSuchePersistSafeHttpUrl(raw: unknown): string {
  const url = clipPortalSuchePersistText(raw, 300);
  if (!url.startsWith('http')) return '';
  if (portalSuchePersistLooksLikeUrlDump(url) || portalSuchePersistLooksLikePii(url)) return '';
  return url;
}

function sanitizePortalSuchePersistedChip(raw: unknown): PortalSucheQueryChip | null {
  const rec = asRecord(raw);
  if (!rec) return null;
  const query = clipPortalSuchePersistText(rec.query, PORTAL_SUCHE_PERSIST_MAX_TEXT);
  const key = clipPortalSuchePersistText(rec.key, 80);
  if (!query || !key) return null;
  if (portalSuchePersistLooksLikePii(query) || portalSuchePersistLooksLikePii(key)) return null;
  const label = clipPortalSuchePersistText(rec.label, PORTAL_SUCHE_PERSIST_MAX_TEXT) || query;
  const normId = clipPortalSuchePersistText(rec.normId, 40);
  return { key, query, label, normId };
}

function sanitizePortalSuchePersistedBlock(raw: unknown): PortalSucheComposeBlock | null {
  const rec = asRecord(raw);
  if (!rec) return null;
  const key = clipPortalSuchePersistText(rec.key, 80);
  const paragraph = clipPortalSuchePersistText(rec.paragraph, PORTAL_SUCHE_PERSIST_MAX_TEXT);
  if (!key || !paragraph) return null;
  const status = rec.status === 'skip' ? 'skip' : rec.status === 'hit' ? 'hit' : null;
  if (!status) return null;
  const title = clipPortalSuchePersistText(rec.title, PORTAL_SUCHE_PERSIST_MAX_TEXT);
  const body = clipPortalSuchePersistBody(rec.body, PORTAL_SUCHE_PERSIST_MAX_BODY);
  if (portalSuchePersistLooksLikePii(title) || portalSuchePersistLooksLikePii(body)) return null;
  const risUrl = clipPortalSuchePersistText(rec.risUrl, 300);
  const summaryRaw = clipPortalSuchePersistText(rec.summary, PORTAL_SUCHE_PERSIST_MAX_ORIENTATION);
  const summary =
    summaryRaw && !portalSuchePersistLooksLikePii(summaryRaw) ? summaryRaw : '';
  return {
    key,
    paragraph,
    status,
    title,
    body,
    risUrl: risUrl.startsWith('http') ? risUrl : '',
    summary: summary || undefined,
  };
}

function sanitizePortalSuchePersistedPathChip(raw: unknown): PortalSucheComposePathChip | null {
  const rec = asRecord(raw);
  if (!rec) return null;
  const key = clipPortalSuchePersistText(rec.key, 80);
  const label = clipPortalSuchePersistText(rec.label, PORTAL_SUCHE_PERSIST_MAX_TEXT);
  if (!key || !label) return null;
  const status = rec.status === 'skip' ? 'skip' : rec.status === 'hit' ? 'hit' : null;
  if (!status) return null;
  let source = clipPortalSuchePersistText(rec.source, 80);
  if (/token|weight|logit|LEXCORE|JUDICATURE/i.test(source)) {
    source =
      status === 'hit'
        ? PORTAL_SUCHE_MARKED_PATH_SOURCE_LEX
        : PORTAL_SUCHE_MARKED_PATH_SOURCE_NORM;
  }
  if (!source) {
    source =
      status === 'hit'
        ? PORTAL_SUCHE_MARKED_PATH_SOURCE_LEX
        : PORTAL_SUCHE_MARKED_PATH_SOURCE_NORM;
  }
  return { key, label, status, source };
}

function sanitizePortalSuchePersistedCompose(
  raw: unknown,
  chips: readonly PortalSucheQueryChip[],
): PortalSuchePersistedCompose | null {
  const rec = asRecord(raw);
  if (!rec || !chips.length) return null;
  const allow = new Set(chips.map((chip) => chip.key));
  const blocks = (Array.isArray(rec.blocks) ? rec.blocks : [])
    .map(sanitizePortalSuchePersistedBlock)
    .filter((block): block is PortalSucheComposeBlock => Boolean(block && allow.has(block.key)));
  if (!blocks.length) return null;
  const selected = portalSucheChipsToExploreHits(chips).filter((hit) =>
    blocks.some((block) => block.key === hit.key),
  );
  if (!selected.length) return null;
  const pathRec = asRecord(rec.path);
  const pathFromStore = (Array.isArray(pathRec?.chips) ? pathRec!.chips : [])
    .map(sanitizePortalSuchePersistedPathChip)
    .filter((chip): chip is PortalSucheComposePathChip => Boolean(chip && allow.has(chip.key)));
  const path = buildPortalSucheComposePath({
    selected,
    blocks,
    filteredSources: blocks
      .filter((block) => block.status === 'hit')
      .map((block) => ({
        norm_id: block.key,
        title: block.title,
        fragment_text: block.status === 'hit' ? block.title : '',
        ris_url: block.risUrl,
      })),
  });
  if (pathFromStore.length === selected.length) {
    path.chips = pathFromStore;
    path.steps = portalSucheComposePathSteps(path);
  }
  if (portalSucheComposePathHasExtraNorm(path, selected)) return null;
  const storedOrientation = clipPortalSuchePersistText(
    rec.orientation,
    PORTAL_SUCHE_PERSIST_MAX_ORIENTATION,
  );
  const orientation =
    storedOrientation && !portalSuchePersistLooksLikePii(storedOrientation)
      ? storedOrientation
      : blocks.map(portalSucheOrientationSentence).filter(Boolean).slice(0, 4).join(' ');
  if (!orientation) return null;
  return { orientation, blocks, path };
}

function sanitizePortalSuchePersistedSource(raw: unknown): PortalSuchePersistedSource | null {
  const rec = asRecord(raw);
  if (!rec) return null;
  const norm_id = clipPortalSuchePersistText(rec.norm_id || rec.normId, 40);
  if (!norm_id) return null;
  const title = portalSuchePersistSafeText(rec.title, PORTAL_SUCHE_PERSIST_MAX_TEXT);
  const fragment_text = portalSuchePersistSafeBody(
    rec.fragment_text || rec.fragmentText,
    PORTAL_SUCHE_PERSIST_MAX_BODY,
  );
  return {
    norm_id,
    title,
    fragment_text,
    ris_url: portalSuchePersistSafeHttpUrl(rec.ris_url || rec.risUrl),
  };
}

function sanitizePortalSuchePersistedCase(raw: unknown): PortalSuchePersistedCase | null {
  const rec = asRecord(raw);
  if (!rec) return null;
  const case_id = clipPortalSuchePersistText(rec.case_id || rec.caseId, 80);
  const geschaeftszahl = clipPortalSuchePersistText(rec.geschaeftszahl, PORTAL_SUCHE_PERSIST_MAX_TEXT);
  if (!case_id && !geschaeftszahl) return null;
  const leitsatz = portalSuchePersistSafeText(rec.leitsatz, PORTAL_SUCHE_PERSIST_MAX_BODY);
  return {
    case_id: case_id || geschaeftszahl,
    geschaeftszahl: geschaeftszahl || case_id,
    leitsatz,
    source_url: portalSuchePersistSafeHttpUrl(rec.source_url || rec.sourceUrl),
  };
}

function sanitizePortalSuchePersistedSearch(raw: unknown): PortalSuchePersistedSearch | null {
  const rec = asRecord(raw);
  if (!rec) return null;
  const mode: PortalSucheMode = rec.mode === 'explore' ? 'explore' : 'cite';
  const query = portalSuchePersistSafeText(rec.query, PORTAL_SUCHE_PERSIST_MAX_TEXT);
  const text = portalSuchePersistSafeText(rec.text, PORTAL_SUCHE_PERSIST_MAX_ORIENTATION);
  const sources: PortalSuchePersistedSource[] = [];
  const seenNorm = new Set<string>();
  for (const item of Array.isArray(rec.sources) ? rec.sources : []) {
    const source = sanitizePortalSuchePersistedSource(item);
    if (!source || seenNorm.has(source.norm_id)) continue;
    seenNorm.add(source.norm_id);
    sources.push(source);
    if (sources.length >= PORTAL_SUCHE_PERSIST_MAX_SOURCES) break;
  }
  const cases: PortalSuchePersistedCase[] = [];
  const seenCase = new Set<string>();
  for (const item of Array.isArray(rec.cases) ? rec.cases : []) {
    const row = sanitizePortalSuchePersistedCase(item);
    if (!row || seenCase.has(row.case_id)) continue;
    seenCase.add(row.case_id);
    cases.push(row);
    if (cases.length >= PORTAL_SUCHE_PERSIST_MAX_CASES) break;
  }
  if (!query && !text && !sources.length && !cases.length) return null;
  return { mode, query, text, sources, cases };
}

export function sanitizePortalSuchePersistedState(raw: unknown): PortalSuchePersistedState {
  const rec = asRecord(raw);
  if (!rec) return emptyPortalSuchePersistedState();
  if (rec.v !== PORTAL_SUCHE_PERSIST_VERSION) return emptyPortalSuchePersistedState();
  if (!Array.isArray(rec.chips)) return emptyPortalSuchePersistedState();
  const kind: PortalSucheKind = rec.kind === 'jud' ? 'jud' : 'lex';
  const chips: PortalSucheQueryChip[] = [];
  const seen = new Set<string>();
  for (const item of rec.chips) {
    const chip = sanitizePortalSuchePersistedChip(item);
    if (!chip || seen.has(chip.key)) continue;
    seen.add(chip.key);
    chips.push(chip);
    if (chips.length >= PORTAL_SUCHE_PERSIST_MAX_CHIPS) break;
  }
  const compose = chips.length ? sanitizePortalSuchePersistedCompose(rec.compose, chips) : null;
  const search = sanitizePortalSuchePersistedSearch(rec.search);
  const query =
    portalSuchePersistSafeText(rec.query, PORTAL_SUCHE_PERSIST_MAX_TEXT) || search?.query || '';
  const view: PortalSuchePersistedView = compose ? 'compose' : 'search';
  return {
    v: PORTAL_SUCHE_PERSIST_VERSION,
    kind,
    query,
    view,
    chips,
    search: compose ? null : search,
    compose,
  };
}

export function parsePortalSuchePersistedJson(raw: string | null | undefined): PortalSuchePersistedState {
  if (raw == null || typeof raw !== 'string' || !raw.trim()) {
    return emptyPortalSuchePersistedState();
  }
  if (raw.length > PORTAL_SUCHE_PERSIST_MAX_JSON) {
    return emptyPortalSuchePersistedState();
  }
  try {
    return sanitizePortalSuchePersistedState(JSON.parse(raw) as unknown);
  } catch {
    return emptyPortalSuchePersistedState();
  }
}

export function serializePortalSuchePersistedState(state: PortalSuchePersistedState): string {
  const clean = sanitizePortalSuchePersistedState(state);
  return JSON.stringify({
    v: clean.v,
    kind: clean.kind,
    query: clean.query,
    view: clean.view,
    chips: clean.chips,
    search: clean.search,
    compose: clean.compose,
  });
}

export function portalSuchePersistFromView(opts: {
  kind: PortalSucheKind;
  query?: string;
  view?: PortalSuchePersistedView;
  chips: readonly PortalSucheQueryChip[];
  search?: PortalSuchePersistedSearch | null;
  compose: PortalSuchePersistedCompose | null;
}): PortalSuchePersistedState {
  return sanitizePortalSuchePersistedState({
    v: PORTAL_SUCHE_PERSIST_VERSION,
    kind: opts.kind,
    query: opts.query || '',
    view: opts.view || (opts.compose ? 'compose' : 'search'),
    chips: opts.chips.slice(),
    search: opts.search ?? null,
    compose: opts.compose,
  });
}

export function portalSucheSearchSnapshotFromHit(hit: {
  mode?: PortalSucheMode;
  query?: string;
  text?: string;
  lexProof?: unknown;
  judProof?: unknown;
} | null | undefined): PortalSuchePersistedSearch | null {
  if (!hit) return null;
  const sources = portalSucheComposeSourcesFromLexProof(hit.lexProof).map((row) => ({
    norm_id: row.norm_id,
    title: row.title || '',
    fragment_text: row.fragment_text || '',
    ris_url: row.ris_url || '',
  }));
  const proofRec = asRecord(hit.judProof);
  const rawCases = Array.isArray(proofRec?.cases) ? proofRec!.cases : [];
  const cases = rawCases.map((item) => {
    const rec = asRecord(item);
    if (!rec) return null;
    return {
      case_id: String(rec.case_id || rec.caseId || '').trim(),
      geschaeftszahl: String(rec.geschaeftszahl || '').trim(),
      leitsatz: String(rec.leitsatz || '').trim(),
      source_url: String(rec.source_url || rec.sourceUrl || '').trim(),
    };
  });
  return sanitizePortalSuchePersistedSearch({
    mode: hit.mode === 'explore' ? 'explore' : 'cite',
    query: hit.query || '',
    text: hit.text || '',
    sources,
    cases: cases.filter(Boolean),
  });
}

export function portalSucheComposeSnapshotFromHit(hit: {
  text?: string;
  composeBlocks?: readonly PortalSucheComposeBlock[] | null;
  composePath?: PortalSucheComposePath | null;
} | null | undefined): PortalSuchePersistedCompose | null {
  if (!hit) return null;
  const blocks = Array.isArray(hit.composeBlocks) ? hit.composeBlocks.slice() : [];
  const path = hit.composePath;
  if (!blocks.length || !path || !Array.isArray(path.chips) || !path.chips.length) return null;
  return {
    orientation: clipPortalSuchePersistText(hit.text, PORTAL_SUCHE_PERSIST_MAX_ORIENTATION),
    blocks,
    path,
  };
}

function defaultPortalSuchePersistStore(): PortalSuchePersistStore | null {
  try {
    if (typeof localStorage === 'undefined' || !localStorage) return null;
    return localStorage;
  } catch {
    return null;
  }
}

export function loadPortalSuchePersist(
  seatId?: string | null,
  store?: PortalSuchePersistStore | null,
): PortalSuchePersistedState {
  const storage = store === undefined ? defaultPortalSuchePersistStore() : store;
  if (!storage) return emptyPortalSuchePersistedState();
  const key = portalSuchePersistStorageKey(seatId);
  const localKey = portalSuchePersistStorageKey('');
  try {
    let raw = storage.getItem(key);
    if ((raw == null || !String(raw).trim()) && key !== localKey) {
      const fallback = storage.getItem(localKey);
      if (fallback != null && String(fallback).trim()) {
        raw = fallback;
        try {
          storage.setItem(key, fallback);
          storage.removeItem(localKey);
        } catch {
          /* quota / private */
        }
      }
    }
    if (raw == null || !String(raw).trim()) return emptyPortalSuchePersistedState();
    try {
      JSON.parse(raw);
    } catch {
      try {
        storage.removeItem(key);
      } catch {
        /* private / blocked */
      }
      return emptyPortalSuchePersistedState();
    }
    return parsePortalSuchePersistedJson(raw);
  } catch {
    return emptyPortalSuchePersistedState();
  }
}

export function savePortalSuchePersist(
  state: PortalSuchePersistedState,
  seatId?: string | null,
  store?: PortalSuchePersistStore | null,
): void {
  const storage = store === undefined ? defaultPortalSuchePersistStore() : store;
  if (!storage) return;
  const key = portalSuchePersistStorageKey(seatId);
  const clean = sanitizePortalSuchePersistedState(state);
  try {
    if (portalSuchePersistIsEmpty(clean)) {
      storage.removeItem(key);
      return;
    }
    storage.setItem(key, serializePortalSuchePersistedState(clean));
  } catch {
    /* quota / private mode — UI bleibt, Persistenz fällt aus */
  }
}

export function portalSucheHitFieldsFromPersist(state: PortalSuchePersistedState): {
  kind: PortalSucheKind;
  mode: 'cite';
  text: string;
  composeBlocks: PortalSucheComposeBlock[];
  composePath: PortalSucheComposePath;
} | null {
  if (!state.compose) return null;
  return {
    kind: state.kind,
    mode: 'cite',
    text: state.compose.orientation,
    composeBlocks: state.compose.blocks,
    composePath: state.compose.path,
  };
}

export function portalSucheSearchHitFieldsFromPersist(state: PortalSuchePersistedState): {
  kind: PortalSucheKind;
  mode: PortalSucheMode;
  query: string;
  text: string;
  sources: PortalSuchePersistedSource[];
  cases: PortalSuchePersistedCase[];
} | null {
  if (!state.search) return null;
  return {
    kind: state.kind,
    mode: state.search.mode,
    query: state.search.query || state.query || '',
    text: state.search.text,
    sources: state.search.sources,
    cases: state.search.cases,
  };
}

/** Reload-Stand für die Suche-View — Query, Chips, freie Suche oder Compose. */
export function portalSucheViewSnapshotFromPersist(state: PortalSuchePersistedState): {
  kind: PortalSucheKind;
  query: string;
  view: PortalSuchePersistedView;
  chips: PortalSucheQueryChip[];
  search: PortalSuchePersistedSearch | null;
  compose: PortalSuchePersistedCompose | null;
} {
  const clean = sanitizePortalSuchePersistedState(state);
  return {
    kind: clean.kind,
    query: clean.query || clean.search?.query || '',
    view: clean.view,
    chips: clean.chips,
    search: clean.search,
    compose: clean.compose,
  };
}
